import type { NameFieldType, NameInputKey } from '@/src/Types/GF/Fields';
import { ErrorIcon } from '@Views/Shared/Icons';

import Input from '../../components/Input';

type Props = {
	field: NameFieldType;
	setFormValues: React.Dispatch<any>;
	formValues: any;
	errorMessage: string;
};

export default function NameField({ field, setFormValues, formValues, errorMessage }: Props) {
	const { id, formId, type, label, description, cssClass, inputs, isRequired } = field;
	const htmlId = `field_${formId}_${id}`;

	inputs.forEach((input) => {
		if (input.id === `${id}.2`) {
			input.key = 'prefix';
		}
		if (input.id === `${id}.3`) {
			input.key = 'first';
		}
		if (input.id === `${id}.4`) {
			input.key = 'middle';
		}
		if (input.id === `${id}.6`) {
			input.key = 'last';
		}
		if (input.id === `${id}.8`) {
			input.key = 'suffix';
		}
	});

	const prefixInput = inputs?.find((input) => input?.key === 'prefix');
	const otherInputs = inputs?.filter((input) => input?.key !== 'prefix') || [];

	const updateValues = (value: any, slug: string) => {
		const _form = { ...formValues };
		_form.values[`input_${slug.replace('.', '_')}`] = value;
		setFormValues(_form);
	};

	return (
		<fieldset id={htmlId} className={`gfield gfield-${type} ${cssClass}`.trim()}>
			{label && (
				<legend
					className={`mb-3 ${
						isRequired &&
						'after:ml-0.5 after:font-semibold after:text-minos-form-require-color after:content-["*"]'
					}`}
				>
					{label}
				</legend>
			)}
			{errorMessage && (
				<p className={`mb-3 mt-1 inline-flex items-center gap-2 text-base text-minos-form-error-color`}>
					<ErrorIcon />
					{errorMessage}
				</p>
			)}
			{prefixInput && !prefixInput.isHidden ? (
				<>
					<select
						required={Boolean(isRequired)}
						name={String(prefixInput.key)}
						id={`input_${formId}_${id}_${prefixInput.key}`}
						autoComplete={prefixInput.autocompleteAttribute}
						onChange={(e) => updateValues(e.target.value, prefixInput.id)}
					>
						<option value=''></option>
						{prefixInput.choices?.map((choice) => (
							<option key={choice?.value} value={String(choice?.value)}>
								{String(choice?.text)}
							</option>
						))}
					</select>
					<label htmlFor={`input_${formId}_${id}_${prefixInput.key}`}>
						{prefixInput.customLabel || prefixInput.label}
					</label>
				</>
			) : null}
			{otherInputs.map((input) => {
				const key: NameInputKey | undefined = input?.key;
				const inputLabel = input?.customLabel || input?.label;
				const placeholder = input?.defaultValue || inputLabel;
				return (
					<div className='' key={key}>
						{!input.isHidden && (
							<Input
								type='text'
								ariaLabel={inputLabel}
								name={String(key)}
								id={`input_${formId}_${id}_${key}`}
								placeholder={placeholder}
								required={Boolean(isRequired)}
								autoComplete={input.autocompleteAttribute}
								onChange={(e) => updateValues(e.target.value, input?.id)}
								label={inputLabel}
								htmlFor={`input_${formId}_${id}_${key}`}
								description={description}
							/>
						)}
					</div>
				);
			})}
		</fieldset>
	);
}
